import { Children, cloneElement, forwardRef } from "react";
import { Inline } from "../../layout";
import { slot } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "span";
export function InnerIconList({
  as = DefaultElement,
  children,
  disabled,
  forwardedRef,
  size,
  ...rest
}) {
  return /*#__PURE__*/_jsx(Inline, { ...rest,
    "aria-hidden": "true",
    as: as,
    gap: 1,
    ref: forwardedRef,
    children: Children.toArray(children).filter(x => x).map(x => {
      return /*#__PURE__*/cloneElement(x, {
        disabled,
        size
      });
    })
  });
}
InnerIconList.defaultElement = DefaultElement;
export const IconList = slot("icon", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerIconList, { ...props,
  forwardedRef: ref
})));